/**
 * Imperative master stereo RMS bars for the transport time readout.
 * Horizontal scaleX (L on top); rAF only — no React per frame.
 */
import { meterHeightFromRms, type EngineTelemetry } from "../../../../src/lib/audio";
import { createMeterClock, smoothMeterLevel } from "./meterSmooth";

let leftBar: HTMLElement | null = null;
let rightBar: HTMLElement | null = null;
let shownL = 0;
let shownR = 0;
let rafId = 0;
let getTelemetry: (() => EngineTelemetry) | null = null;
const clock = createMeterClock();

export function setMasterMeterHost(options: {
  left: HTMLElement;
  right: HTMLElement;
  getTelemetry: () => EngineTelemetry;
} | null): void {
  leftBar = options?.left ?? null;
  rightBar = options?.right ?? null;
  getTelemetry = options?.getTelemetry ?? null;
  if (!options) {
    stopPump();
    shownL = 0;
    shownR = 0;
    apply();
    return;
  }
  clock.reset();
  startPump();
}

function startPump(): void {
  if (rafId !== 0) {
    return;
  }
  const tick = () => {
    rafId = requestAnimationFrame(tick);
    paint();
  };
  rafId = requestAnimationFrame(tick);
}

function stopPump(): void {
  if (rafId === 0) {
    return;
  }
  cancelAnimationFrame(rafId);
  rafId = 0;
}

function apply(): void {
  if (leftBar) {
    leftBar.style.transform = `scaleX(${shownL})`;
  }
  if (rightBar) {
    rightBar.style.transform = `scaleX(${shownR})`;
  }
}

function paint(): void {
  if (!getTelemetry || !leftBar || !rightBar) {
    return;
  }
  const dt = clock.dt();
  const master = getTelemetry().master;
  shownL = smoothMeterLevel(shownL, meterHeightFromRms(master.rmsL), dt);
  shownR = smoothMeterLevel(shownR, meterHeightFromRms(master.rmsR), dt);
  apply();
}
